import React, { lazy } from 'react';
import { CheckCircle2, AlertTriangle, Info } from 'lucide-react';
export function RepairOrReplace() {
  return <section className="py-16 lg:py-24 bg-slate-50 border-t border-slate-200" data-id="element-319">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-320">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-10 lg:gap-12 items-center mb-16" data-id="element-321">
          <div className="lg:col-span-2 relative scroll-slide-left" data-id="element-322">
            <div className="rounded-2xl overflow-hidden shadow-xl shadow-slate-300/40 border border-slate-200" data-id="element-323">
              <img src="https://cdn.magicpatterns.com/uploads/pKBPgQ1xSW19doAJvWE4xG/autoglasspic3.webp" alt="Cracked windshield with spreading damage. Kosin's Glass inspects damage to recommend repair or replacement." className="block w-full h-64 lg:h-80 object-cover" loading="lazy" data-id="element-324" />
            </div>
            <div className="hidden lg:block absolute -bottom-4 -right-4 w-24 h-24 bg-brand-blue rounded-2xl -z-10" data-id="element-325" />
          </div>

          <div className="lg:col-span-3 scroll-slide-right" data-id="element-326">
            <h2 className="text-3xl md:text-4xl font-bold text-navy-900 mb-4" data-id="element-327">
              Should You Repair or Replace Your Windshield?
            </h2>
            <p className="text-lg text-slate-600 leading-relaxed" data-id="element-328">
              Not every chip means a full replacement, and not every crack is
              safe to drive with. Here's how to tell the difference, and why it
              matters for your safety and your insurance claim.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-5xl mx-auto mb-12" data-id="element-329">
          <div className="bg-white rounded-2xl p-8 shadow-md border border-slate-100 relative overflow-hidden scroll-slide-left" data-id="element-330">
            <div className="absolute top-0 left-0 w-full h-1 bg-emerald-500" data-id="element-331"></div>
            <div className="flex items-center gap-4 mb-6" data-id="element-332">
              <div className="w-12 h-12 bg-emerald-50 rounded-full flex items-center justify-center shrink-0" data-id="element-333">
                <CheckCircle2 className="w-6 h-6 text-emerald-600" data-id="element-334" />
              </div>
              <h3 className="text-2xl font-bold text-navy-900" data-id="element-335">
                Repair may be possible when…
              </h3>
            </div>
            <ul className="space-y-4" data-id="element-336">
              {['The chip is small and contained', "The damage is away from the driver's direct line of sight", 'The damage is not near the windshield edge', 'Dirt and moisture have not contaminated the damaged area'].map((bullet, i) => <li key={i} className="flex items-start gap-3" data-id="element-337">
                  <div className="w-1.5 h-1.5 rounded-full bg-emerald-500 mt-2.5 shrink-0" data-id="element-338"></div>
                  <span className="text-slate-700 text-lg" data-id="element-339">{bullet}</span>
                </li>)}
            </ul>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-md border border-slate-100 relative overflow-hidden scroll-slide-right" data-id="element-340">
            <div className="absolute top-0 left-0 w-full h-1 bg-amber-500" data-id="element-341"></div>
            <div className="flex items-center gap-4 mb-6" data-id="element-342">
              <div className="w-12 h-12 bg-amber-50 rounded-full flex items-center justify-center shrink-0" data-id="element-343">
                <AlertTriangle className="w-6 h-6 text-amber-600" data-id="element-344" />
              </div>
              <h3 className="text-2xl font-bold text-navy-900" data-id="element-345">
                Replacement is usually safer when…
              </h3>
            </div>
            <ul className="space-y-4" data-id="element-346">
              {['The windshield has a spreading crack', "Damage blocks or distorts the driver's view", 'Damage is near the edge of the glass', 'Multiple chips or spreading cracks are present', 'ADAS cameras or sensors may be affected'].map((bullet, i) => <li key={i} className="flex items-start gap-3" data-id="element-347">
                  <div className="w-1.5 h-1.5 rounded-full bg-amber-500 mt-2.5 shrink-0" data-id="element-348"></div>
                  <span className="text-slate-700 text-lg" data-id="element-349">{bullet}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="max-w-3xl mx-auto bg-brand-light/60 border border-red-100 rounded-xl p-6 flex flex-col sm:flex-row items-start sm:items-center gap-4 mb-10" data-id="element-350">
          <Info className="w-6 h-6 text-brand-blue shrink-0" data-id="element-351" />
          <p className="text-sm text-slate-700 leading-relaxed" data-id="element-352">
            A chip repair is meant to help stop damage from spreading. It may
            still be visible after repair. Kosin's Glass can inspect the glass
            and explain the safest option.
          </p>
        </div>

        <div className="text-center" data-id="element-353">
          <a href="#quote" className="inline-flex items-center justify-center bg-white border-2 border-brand-blue text-brand-blue hover:bg-brand-light font-bold text-lg py-3 px-8 rounded-xl transition-colors" data-id="element-354">
            Request an Inspection
          </a>
        </div>
      </div>
    </section>;
}